import Login from './components/Login'
import App from './components/App'
import Users from './components/users/Users.vue'
import User from './components/users/User.vue'
import Blacklist from './components/users/Blacklist'
import Followees from './components/users/Followees'
import dashboardRoutes from './components/dashboard/routes'
import newsRoutes from './components/news/routes'
import moderationRoutes from './components/moderation/routes'
import vouchersRoutes from './components/vouchers/routes'
import serversRoutes from './components/servers/routes'
import suggestionsRoutes from './components/suggestions/routes'
import apiRoutes from './components/apilogs/routes'

import store from './store'
import { makeEntityExistsGuard } from './store/utils'

export default [
  { path: '',
    component: App,
    beforeEnter (to, from, next) {
      if (store.getters['auth/authenticated']) {
        next()
      } else {
        store.dispatch('auth/autologin').then(() => {
          next()
        }, () => {
          next('/login')
        })
      }
    },
    children: [
      ...dashboardRoutes,
      { path: '', redirect: '/dashboard' },
      { path: '/users', name: 'users', component: Users },
      { path: '/users/:id(\\d+)',
        name: 'user',
        component: User,
        beforeEnter: makeEntityExistsGuard('users')
      },
      { path: '/users/blacklist', name: 'blacklist', component: Blacklist },
      { path: '/users/followees', name: 'followees', component: Followees },
      { path: '/logout',
        beforeEnter (to, from, next) {
          store.dispatch('auth/logout').then(() => {
            next('/login')
          })
        }
      },
      ...newsRoutes,
      ...moderationRoutes,
      ...suggestionsRoutes,
      ...vouchersRoutes,
      ...serversRoutes,
      ...apiRoutes
    ]
  },
  { path: '/login',
    component: Login,
    beforeEnter (to, from, next) {
      if (store.getters['auth/authenticated']) {
        next(from)
      } else {
        store.dispatch('auth/autologin').then(() => {
          next(from)
        }, () => {
          next()
        })
      }
    }
  }
]



// WEBPACK FOOTER //
// ./src/routes.js